const re = new RegExp(/^\d{6}$/)
const validOTP = (input) =>{
    if(!re.test(String(input)))
    {
        return("Please enter valid verification code")
    }
}

export default validOTP